import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";
import {SplitService} from "../../services/split-service.service";

export class ProgramTypeSelectComponent implements IController {

  selectedProgramId: any;
  options: any[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeOptions: string[];
  ngPlaceholder: string;
  optionsPrefix: string;
  isHideResetButton: boolean;
  isHideLabel: boolean;
  onChange: Function;

  public selectedText: string;

  constructor(private $mdPanel, private splitService: SplitService) {
  }

  $onInit() {
    if (!this.options?.length) {
      this.options = this.splitService.getSiteProgramTypes();
    }
    this._setSelectedText();
  };

  $onChanges(changes: IOnChangesObject) {
    if (changes.selectedProgramId && !changes.selectedProgramId.isFirstChange()) {
      this._setSelectedText();
    }

  }


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedProgramId;
    const optionsRef = this.options;
    const excludeIdsRef = this.excludeOptions;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdRef" ' +
        'options-prefix="{{ctrl.optionsPrefixRef}}" ' +
        'options="ctrl.optionsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'program'
        this.selectedIdRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({selectedProgramId: undefined});
        } else {
          this.onChange({selectedProgramId: selectedId});
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedProgramId: undefined});
  }

  private _setSelectedText() {
    if (this.selectedProgramId) {
      this.selectedText = this.options.find((program) => {
        return program.id === this.selectedProgramId;
      })?.type;
    } else {
      this.selectedText = undefined;
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('programTypeSelect', {
    bindings: {
      selectedProgramId: '<?',
      options: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeOptions: '<?',
      isHideResetButton: '<?',
      isHideLabel: '<?',
      ngPlaceholder: '@?',
      onChange: '&?'
    },
    template: require('./program-type-select.html').default,
    controller: ProgramTypeSelectComponent
  });

